import {use} from 'react'
import {DimensionsContext} from './dimensions-context'
import {type Dimensions} from './types/dimensions'

export function useDimensions(): Dimensions {
    return use(DimensionsContext)
}
